import React from "react";

function AboutHero() {
  return (
    <section className="about-hero">
      <div className="about-hero__inner">
        <h1 className="about-hero__title">
          Helping you invest with clarity, discipline, and trust
        </h1>

        <p className="about-hero__subtitle">
          At Swiftfolios, we combine fiduciary principles with personalised
          wealth solutions — making investing simple and purposeful.
        </p>

        <p className="about-hero__meta">
          From tailored portfolios to seamless execution for HNIs and families,
          we focus on what matters most: your financial goals.
        </p>
      </div>
    </section>
  );
}

export default AboutHero;